// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vzC3","index":"styles_index__3l9Mn"};